// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-wrapper[data-v-783b9cde] {\n  display: flex;\n  align-items: center;\n}\n.right-button[data-v-783b9cde],\n.left-button[data-v-783b9cde] {\n  display: flex;\n  padding: 7px 12px;\n  margin-left: 8px;\n}\n.right-button[data-v-783b9cde] {\n  transform: rotate(180deg);\n}\n", ""]);
// Exports
module.exports = exports;
